import { Injectable } from '@angular/core';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { DomainService } from 'src/app/services/domain/domain.service';
import { environment } from 'src/environments/environment';
import { DomainsModel } from 'src/app/models/domains.model';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { EmarsysService } from 'src/app/services/track/emarsys.service';
import { GlobalsService } from '../globals/globals.service';
import { EncriptService } from '../encript/encript.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectToMainSiteService {
  domainInfo: DomainsModel;
  upsell = environment.upsellPage;
  system: string;
  AES_CODE = environment.AES_CODE;

  constructor(
    private _storageService: StoragePermissionService,
    private _domainService: DomainService,
    private _winRef: WindorefService,
    private _emarsys: EmarsysService,
    private _global: GlobalsService,
    private windowRef: WindorefService,
    private _encript: EncriptService
  ) {
    this.domainInfo = this._domainService.getCurrentDomain();
    this.system = this._global.getSystem().site;
  }
async doWork() {
    for (let i = 70; i <= 100; i++) {
      const progress = parseInt(String(i), 10);
      localStorage.setItem('spinnerProgress', String(progress));
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }

  siteRedirect(landingHash: string = null): void {
    this._emarsys.launchGo();
    this._storageService.setUsage();
    const path = this.windowRef.getNativeDocument().location.pathname;
    if (path.includes('freeplay') || path.includes('freespin') || path.includes('deposit')) {
      this.doWork().then(r => this.runRedirect(landingHash));
    }
    this.runRedirect(landingHash)
  }

  runRedirect(landingHash){
    landingHash = landingHash === null ? '' : `?landingHash=${landingHash}`;
    let parentDomain = this._storageService.getDomainToRedirect();
    let currentDomain = this.domainInfo.domain;
    let windows = this._winRef.getNativeWindow().window;
    const promoSyndicate = environment.promoSyndicate;

    let promocode = '';
    let { type, pcode } = environment;
    if (type === 'casino-deposit') promocode = `&depositCode=${pcode[this.system]}`;

    if (this.domainInfo.upsell === false) this.upsell = null;

    if (this.upsell) {
      window.location.href = `https://${currentDomain}/${this.upsell}/${landingHash}`;
    } else if (promoSyndicate) {
      const promo = 'SYNDICATE';
      windows.location.href = `${parentDomain}${landingHash}${promocode}&promo=${promo}`;
    } else {
      windows.location.href = `${parentDomain}${landingHash}${promocode}`;
    }
  }

  siteRedirectHalfUser(profile: any): void {
    this._emarsys.launchGo();
    this._storageService.setUsage();

    let parentDomain = this._storageService.getDomainToRedirect();
    let currentDomain = this.domainInfo.domain;
    let windows = this._winRef.getNativeWindow().window;
    const promoSyndicate = environment.promoSyndicate;

    let encrypted = this._encript.set(this.AES_CODE, profile.identifier);

    let promocode = '';
    let { type, pcode } = environment;
    if (type === 'casino-deposit') promocode = `&depositCode=${pcode[this.system]}`;

    if (this.domainInfo.upsell === false) this.upsell = null;

    if (this.upsell) {
      window.location.href = `https://${currentDomain}/${this.upsell}`;
    } else if (promoSyndicate) {
      const promo = 'SYNDICATE';
      windows.location.href = `${parentDomain}?hu=${encrypted}&promo=${promo}`;
    } else {
      windows.location.href = `${parentDomain}?hu=${encrypted}`;
    }
  }

  redirectToLogin(): void {
    let parentDomain = this._storageService.getDomainToRedirect();
    let windows = this._winRef.getNativeWindow().window;
    windows.location.href = `${parentDomain}/login`;
  }

  errorRedirect(): void {
    this._emarsys.launchGo();
    this._storageService.setUsage();
    let windows = this._winRef.getNativeWindow().window;
    let parentDomain = this._storageService.getDomainToRedirect();
    windows.location.href = `${parentDomain}`;
  }

  redirectWithPromo(promotion) {
    this._emarsys.launchGo();
    this._storageService.setUsage();
    let parentDomain = this._storageService.getDomainToRedirect();
    let { window, location } = this._winRef.getNativeWindow();
    let search = location.search ? `&${location.search.split('?')[1]}` : '';
    window.location.href = `${parentDomain}${promotion}${search}`;
  }
}
